/**
 * Global Styles - App
 *
 * Any global styles overrides or additional styles can be included in this file
 */
import React from 'react';
import { createGlobalStyle, Normalize, thd, up, css } from '@smooth-ui/core-sc';
import loriGlobalStyles from '_platform/src/theme/globalStyles';

export const GlobalStylesApp = createGlobalStyle`
  ${loriGlobalStyles}

  @font-face {
    font-family: 'ApexNew-Book';
    src: url('/fonts/ApexNew-Book.otf');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'ApexNew-BookItalic';
    src: url('/fonts/ApexNew-BookItalic.otf');
    font-weight: 400;
    font-style: italic;
  }

  @font-face {
    font-family: 'ApexNew-Bold';
    src: url('/fonts/ApexNew-Bold.otf');
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'ApexNew-BoldItalic';
    src: url('/fonts/ApexNew-BoldItalic.otf');
    font-weight: 700;
    font-style: italic;
  }

  @font-face {
    font-family: 'ApexNew-Light';
    src: url('/fonts/ApexNew-Light.otf');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'ApexNew-LightItalic';
    src: url('/fonts/ApexNew-LightItalic.otf');
    font-weight: 300;
    font-style: italic;
  }

  body {
    font-family: 'ApexNew-Book', Calibri, Arial, Helvetica, Verdana, sans-serif;
    line-height: 1.6;
      background-color: #efefef;
  }

  /* Custom CSS here */

  .page-container {
    display: flex;
    flex: 1;
    flex-direction: column;
  }

    h1, h2, h3, h4, h5, h6 {
    font-family: 'ApexNew-Bold', Calibri, Arial, Helvetica, Verdana, sans-serif;
    line-height: 1;
  }

  h1,.h1 {
    font-size: 50px;
    ${up(
      'md',
      css`
        font-size: 60px;
      `
    )}
  }

  h2,.h2 {
    font-size: 40px;
  }

  h3,.h3 {
  font-size: 32px;
  }

  h4,.h4 {
    font-size: 28px;
  }

  h5,.h5 {
    font-size: 22px;
  }

  h6,.h6 {
    font-size: 18px;
    margin: 0;
    padding: 0.75rem 0;
  }

  a {
    color: ${thd('defaultLinkColor', 'theme.gray800')};
    &:hover,&:focus {
      text-decoration: none;
    }
  }

  .button {
    background-color: ${thd('primary', '#cd1723')};
    color: white;
    padding: 10px 25px;
    text-decoration: none;

    &:hover, &:focus {
      background-color: white;
      color: ${thd('primary', '#cd1723')};
    }
  }

  /* Don't wrap emails, phones or other non-wrapping strings */
  .nowrap,
  .date,
  .email,
  .phone {
    white-space: nowrap;
  }

  /* Color text */
  .text--red {
    color: ${thd('danger', '#dc3545')};
  }

  .text--white {
    color: #fff;
  }

  .text--primary {
    color: ${thd('primary', '#867455')};
  }

    .text--secondary {
    color: ${thd('secondary', '#867455')};
  }

  /* Align text */
  .text-center,
  .text-centre,
  .text--center,
  .text--centre {
    text-align: center;
  }
  .text-right,
  .text--right {
    text-align: right;
  }
  .text-left,
  .text--left {
    text-align: left;
  }

  .text-small,
  .text--small {
    font-size: 80%;
  }

  .text-tiny,
  .text--tiny {
    font-size: 60%;
  }

  .text-large,
  .text--large {
    font-size: 120%;
  }

  .text-larger,
  .text--larger {
    font-size: 200%;
  }

  .text-normal,
  .text--normal {
    font-weight: normal;
  }
  .text-uppercase,
  .text--uppercase {
    text-transform: uppercase;
  }

  .text--tight {
    margin-bottom: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-top: 0;
  }

  label {
    font-weight: bold;
  }

  /* Handy spacing classes */
  :root {
    --spacer: 2rem;
  }

  .spacer {
    padding-bottom: 40px;
    padding-top: 40px;
    padding-bottom: var(--spacer);
    padding-top: var(--spacer);
  }
  .spacer--small {
    padding-bottom: 20px;
    padding-top: 20px;
    padding-bottom: calc(var(--spacer) / 2);
    padding-top: calc(var(--spacer) / 2);
  }
  .spacer--large {
    padding-bottom: 80px;
    padding-top: 80px;
    padding-bottom: calc(var(--spacer) * 2);
    padding-top: calc(var(--spacer) * 2);
  }
  .spacer--around {
    padding: 40px;
    padding: var(--spacer);
  }
  .spacer--around--small {
    padding: 20px;
    padding: calc(var(--spacer) / 2);
  }
  .spacer--around--large {
    padding: 80px;
    padding: calc(var(--spacer) * 2);
  }
  .spacer--top {
    padding-top: 40px;
    padding-top: var(--spacer);
  }
  .spacer--bottom {
    padding-bottom: 40px;
    padding-bottom: var(--spacer);
  }
  .spacer--top--small,
  .spacer--small--top {
    padding-top: 20px;
    padding-top: calc(var(--spacer) / 2);
  }
  .spacer--bottom--small,
  .spacer--small--bottom {
    padding-bottom: 20px;
    padding-bottom: calc(var(--spacer) / 2);
  }
  .spacer--top--large,
  .spacer--large--top {
    padding-top: 80px;
    padding-top: calc(var(--spacer) * 2);
  }
  .spacer--bottom--large,
  .spacer--large--bottom {
    padding-bottom: 80px;
    padding-bottom: calc(var(--spacer) * 2);
  }

  .Toastify .Toastify__toast--success {
    background: #07bc0c;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  picture {
    display: block;
  }

  .no-scroll::-webkit-scrollbar {
    display: none;
  }

  html.no-scroll {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

`;

const StylesApp = () => (
  <React.Fragment>
    <Normalize />
    <GlobalStylesApp />
  </React.Fragment>
);

export default StylesApp;
